module.exports = __webpack_public_path__ + "img/browser_chrome.c76f4232.svg";